import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';
import { AxiosResponse, AxiosError } from 'axios';
import ForgotPasswordForm, { ResetPasswordRequestInfo } from '../../components/ForgotPasswordForm';
import MainLayout from '../../components/MainLayout';
import StatusMessages, { StatusMessage } from '../../components/StatusMessages';
import { requestUserResetPassword } from '../../api/accounts';
import styles from './ForgotPassword.module.css';

export interface ForgotPasswordProps {
};

// user forgot password page
const ForgotPassword = (props: ForgotPasswordProps): JSX.Element | null => {
  // status messages to display on top
  const [statusMessages, setStatusMessages] = useState<StatusMessage[]>([]);

  // set document title
  useEffect(() => {
    document.title = 'Forgot Password | Sigmoid Academy';
  }, []);

  // handle reset password request
  const handleResetPasswordRequest = async (info: ResetPasswordRequestInfo): Promise<void> => {
    // clear status messages
    setStatusMessages((previousMessages: StatusMessage[]) => []);

    // request password reset
    requestUserResetPassword(
      info.email
    ).then((response: AxiosResponse) => setStatusMessages(
        // update status messages with success message on success
        (previousMessages: StatusMessage[]) => [
          {
            message: 'Password reset instructions have been sent to given email',
            status: 'success'
          }
        ]
      )
    ).catch((error: AxiosError) => setStatusMessages(
        // update status messages with danger message on failure
        (previousMessages: StatusMessage[]) => [
          {
            message: 'Unknown error occurred',
            status: 'error'
          }
        ]
      )
    );
  };

  return (
    <div>
      <MainLayout selectedKey='login'>
        <div className={styles.mainContainer}>
          <Typography.Title
            level={1}
            className={styles.mainHeading}
          >
            Forgot Password
          </Typography.Title>
          <StatusMessages items={statusMessages} />
          <ForgotPasswordForm handleResetPasswordRequest={handleResetPasswordRequest} />
        </div>
      </MainLayout>
    </div>
  );
};

export default ForgotPassword;
